<template>
  <div class="home">
    <header>
      <ax-header></ax-header>
      <ax-banner></ax-banner>
    </header>
    <div class="content-main">
      <router-view></router-view>
    </div>
    <footer>
      <ax-footer></ax-footer>
    </footer>
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <!-- <ax-header></ax-header> -->
    
    <!-- <ax-footer></ax-footer> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import AXbanner from './components/AXbanner.vue'
// import AXcontent from './components/AXcontent.vue'
import header from '@/components/AXheader.vue'
import AXfooter from '@/components/AXfooter.vue'
export default {
  name: 'Home',
  components: {
    // HelloWorld
    'ax-header': header,
    'ax-footer': AXfooter,
    'ax-banner': AXbanner,
    // 'ax-content': AXcontent,
  }
}
</script>
<style lang="scss" scoped>
.content-main{
  margin-bottom: 30px;
}
</style>
